import { get as getCookie, create as createCookie } from './cookies';

/**
 * Checks whether or not user has already visited the playboks page.
 *
 * @returns {boolean} True if the user has visited the playbooks page, false if the user is new.
 */
const hasViewedPlaybooks = () => {
	if (getCookie('omUserVisitedPlaybooks')) {
		return true;
	}

	createCookie('omUserVisitedPlaybooks', 1, 5 * 365);
	return false;
};

export { hasViewedPlaybooks };
